import { render, staticRenderFns } from "./AggregateHedge.vue?vue&type=template&id=9dc0b196&scoped=true"
import script from "./AggregateHedge.vue?vue&type=script&lang=js"
export * from "./AggregateHedge.vue?vue&type=script&lang=js"
import style0 from "./AggregateHedge.vue?vue&type=style&index=0&id=9dc0b196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc0b196",
  null
  
)

export default component.exports